/* © Facilogi. See COPYRIGHT file for full copyright & licensing details. */

export default {
    HOME_title: "Dashboard",
    HOME_collectedThisMonth: "Collected this month",
    HOME_collectedLastMonth: "Collected last month",
    HOME_collectedTotal: "Total collected",
    HOME_mrr: "Monthly recurring revenue",
    HOME_activeCustomers: "Active customers",
    HOME_activeCustomersHint: "Paying subscription in progress",
    HOME_activeUsers: "Active users",
    HOME_activeUsersHint: "Of customers with a paying subscription",
    HOME_freeSubscriptions: "Free subscriptions",
    HOME_freeSubscriptionsHint: "Active, at €0",
    HOME_mrrGap: "Gap with the Console subscriptions: {0}",
    HOME_mrrFromConsole: "Computed from the Console: Stripe is not answering",
    HOME_failedPayments: "Failed payments",
    HOME_topCustomers: "Top customers",
    HOME_topCustomersHint: "All time, tax included",
    HOME_failed: "Failed",
    HOME_newThisMonth: "{0} new this month",
    HOME_activeSubscriptions: "Active subscriptions",
    HOME_revenue12Months: "Collected revenue — last 12 months",
    HOME_topProducts: "Top products",
    HOME_subscriptionsByStatus: "Subscriptions by status",
    HOME_vsLastMonth: "vs last month",
    HOME_noData: "No data yet",
    HOME_metric_Collected: "Collected volume",
    HOME_metric_NewCustomers: "New paying customers",
    HOME_metric_NewSubscriptions: "New subscriptions",
    HOME_metric_MRR: "Monthly recurring revenue",
    HOME_metric_PayingSubscribers: "Paying subscribers",
    HOME_metric_AverageRevenue: "Average revenue per subscriber",
    HOME_metric_Cancellations: "Cancellations",
    HOME_previousPeriod: "previous period",
    HOME_subscriptionsByPlan: "Subscriptions by plan",
    HOME_mrrByRecurrence: "Monthly / yearly recurring revenue",
    HOME_recurrenceMonthly: "Monthly",
    HOME_recurrenceYearly: "Yearly",
    HOME_dateRange: "Date range",
    HOME_compare: "Compare",
    HOME_rangeToday: "Today",
    HOME_rangeLast7Days: "Last 7 days",
    HOME_rangeLast4Weeks: "Last 4 weeks",
    HOME_rangeLast6Months: "Last 6 months",
    HOME_rangeLast12Months: "Last 12 months",
    HOME_rangeCurrentMonth: "Current month",
    HOME_rangeCurrentQuarter: "Current quarter",
    HOME_rangeYearToDate: "Year to date",
    HOME_rangeAllTime: "All time",
    HOME_rangeStart: "Start",
    HOME_rangeEnd: "End",
    HOME_rangeClear: "Clear",
    HOME_rangeApply: "Apply",
    HOME_granularityDay: "Daily",
    HOME_granularityWeek: "Weekly",
    HOME_granularityMonth: "Monthly",
    HOME_comparePrevious: "Previous period",
    HOME_compareYear: "Previous year",
    HOME_subscriptionsSuffix: "subscriptions"
};
